module.exports = __webpack_public_path__ + "img/Ident-2-mobile.deb2b418.png";